import { Avatar, Box, Card, CardContent, Grid, Icon, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IUserCartData } from "../../_common/interface/userCart/iUserCartList";
import { IUserProfileManage } from "../../_common/interface/users/iUserProfileManage";
import { UserNavigation } from "../../_components/navigation/user-navigation";
import { ORANGE_COLOR, PRIMARY_COLOR } from "../../_const/color.const";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { userInformationService } from "../../_services/userInformation.service";
import { UserProfilePageLicenseList } from "./user-profilePageLicenseList";
import { InfoManageLicenseButton } from "./user-infoManageLicenseButton";
import { getDate, getDateTime } from "../../_helpers/dateTime.helper";

export function UserProfilePagePersonalInfo() {

    const { userId, licenseType } = useParams<{ userId: string, licenseType: string }>();

    let navigate = useNavigate();

    const resetData = () => ({
        id: "",
        firstName: '',
        lastName: '',
        name: '',
        email: '',
        phone: '',
        country: '',
        address: '',
        county: '',
        postalCode: '',
        username: '',
        genderId: null,
        dateOfBirth: null,
        nationality: null,
        age: null,
        fines: []
    });

    const resetUserCartData = () => ({
        id: 0,
        isActive: false,
        paidDate: ""
    });

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<IUserProfileManage>(resetData);
    const [userProfileImg, setUserProfileImg] = useState();
    const [userCartData, setUserCartData] = useState<IUserCartData>(resetUserCartData);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const [isLicensesOpen, setIsLicensesOpen] = useState(false);
    const [isInsurancesOpen, setIsInsurancesOpen] = useState(false);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
        fetchUserImg(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return userInformationService
            .get(id)
            .then(
                (json) => {
                    setData(_data => { _data.role = json.roles; return { ..._data, ...json } });
                    if (json.fines.length > 0) {
                        setUserCartData(__data => {
                            __data.id = json.fines[json.fines.length - 1].userCartId;
                            __data.isActive = json.fines[0].userCartIsActive;
                            __data.paidDate = json.fines[json.fines.length - 1].userCartPaidDate;
                            return { ...__data }
                        });

                    }
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function fetchUserImg(id: string) {

        setIsLoading(true)
        return userInformationService
            .getProfileImage(id)
            .then(
                (json) => {
                    setUserProfileImg(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            <Grid item xs={12}>
                <Card sx={{ height: '350px', position: 'relative', display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                    <Box
                        sx={{
                            height: '150px',
                            backgroundColor: PRIMARY_COLOR[1],
                            position: 'relative',
                        }} />

                    <Avatar
                        alt="User Name"
                        src={"data:image/jpeg;charset=utf-8;base64," + userProfileImg}
                        sx={{
                            width: 120,
                            height: 120,
                            position: 'absolute',
                            top: '150px',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            border: '2px solid white',
                            borderRadius: "0px"
                        }} />

                    <CardContent sx={{ textAlign: 'center', mt: '60px' }}>
                        <Typography variant="h5" color={PRIMARY_COLOR[1]}>{data.firstName} {data.lastName}</Typography>
                        <Typography variant="body1">{data.email}</Typography>
                        <Typography variant="body1">{data.dateOfBirth ? getDate(data.dateOfBirth) : "-"} ({data.age ? data.age + "yo" : "???"})  {accountService.isAdmin && <IconButton color="inherit" onClick={() => { navigator.clipboard.writeText(data.dateOfBirth ? getDate(data.dateOfBirth) : ""); }}><Icon>content_copy</Icon></IconButton>}</Typography>

                        {accountService.isAdmin &&
                            <Typography><span style={{ color: ORANGE_COLOR }}>Status:</span> {data.userStatusName}</Typography>
                        }

                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} mb="8px">
                <InfoManageLicenseButton />
            </Grid>

            <Grid item xs={12} mb="8px">
                <UserProfilePageLicenseList />
            </Grid>

        </>

    );

}
